import { loginRequest, sendLoginRequest, sendSignupRequest, sendFacebookLoginRequest, loginSuccess } from '@zola-helpers/client';
import { getCookie } from '../util/storage';
import { trackUserCreated } from '../util/trackingHelper';
import * as ActionType from './types/AuthActionTypes';
import { getUserContext, identifyUser, identifyUserSailthru } from './UserActions';

export function setBusinessUnit(businessUnit) {
  return {
    type: ActionType.SET_BUSINESS_UNIT,
    payload: businessUnit
  };
}

export function login(loginFormRequest) {
  return (dispatch) => {
    dispatch(loginRequest());
    return sendLoginRequest(loginFormRequest)
    .then((data) => {
      dispatch(getUserContext()).then(() => {
        dispatch(identifyUser());
      });
      return data;
    })
    .then(data => identifyUserSailthru(data.email).then(() => data));
  };
}

export function signup(createUserRequest) {
  return (dispatch) => {
    dispatch(loginRequest());
    return sendSignupRequest(createUserRequest)
    .then((data) => {
      dispatch(getUserContext()).then(() => {
        let cookie = getCookie('pkey');
          if (cookie === '') {
            cookie = null;
          }
          trackUserCreated(createUserRequest.email, cookie);
      });
      return data;
    })
    .then(() => identifyUserSailthru(createUserRequest.email, createUserRequest))
    .catch((error) => {
      throw error;
    });
  };
}

export function facebookLogin(fbLoginRequest) {
  return (dispatch) => {
    dispatch(loginRequest());
    return sendFacebookLoginRequest(fbLoginRequest)
      .then((data) => {
        dispatch(loginSuccess(fbLoginRequest.email));
        dispatch(getUserContext()).then(() => {
          dispatch(identifyUser());
        });
        return data;
      })
      .then(data => identifyUserSailthru(fbLoginRequest.email).then(() => data))
      .catch((error) => {
        throw error;
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/AuthActions.js